<h3 class="section-title mb-3">
  {{
    (addressSource === 'applicant'
      ? 'fundApplication.applicantNationalAddressTitle'
      : 'fundApplication.companyNationalAddressTitle'
    ) | translate
  }}
</h3>
<form [formGroup]="form">
  <div class="p-fluid grid">

    <!-- Company address: city only -->
    <ng-container *ngIf="isCompanyCityOnly">
      <div class="field col-12 md:col-12 sm:col-12">
        <label for="city">
          {{ 'address.city' | translate }} <span class="input-star">*</span>
        </label>
        <input id="city" type="text" pInputText formControlName="city" [disabled]="isDetails" />
        <span class="text-danger"
              *ngIf="form.get('city')?.touched && form.get('city')?.invalid">
          {{ 'Shared.REQUIRED' | translate }}
        </span>
      </div>
    </ng-container>

    <!-- Applicant address: all fields — 3 columns first row, 4 second row on md+ -->
    <ng-container *ngIf="!isCompanyCityOnly">

      <!-- Building Number -->
      <div class="field col-12 md:col-4">
        <label for="buildingNumber">
          {{ 'address.buildingNumber' | translate }} <span class="input-star">*</span>
        </label>
        <input id="buildingNumber" type="text" pInputText formControlName="buildingNumber" [disabled]="isDetails" />
        <span class="text-danger"
              *ngIf="form.get('buildingNumber')?.touched && form.get('buildingNumber')?.invalid">
          {{ 'Shared.REQUIRED' | translate }}
        </span>
      </div>

      <!-- Street -->
      <div class="field col-12 md:col-4">
        <label for="street">
          {{ 'address.street' | translate }} <span class="input-star">*</span>
        </label>
        <input id="street" type="text" pInputText formControlName="street" [disabled]="isDetails" />
        <span class="text-danger"
              *ngIf="form.get('street')?.touched && form.get('street')?.invalid">
          {{ 'Shared.REQUIRED' | translate }}
        </span>
      </div>

      <!-- Additional Number -->
      <div class="field col-12 md:col-4">
        <label for="additionalNumber">
          {{ 'address.additionalNumber' | translate }} <span class="input-star">*</span>
        </label>
        <input id="additionalNumber" type="text" pInputText formControlName="additionalNumber" [disabled]="isDetails" />
        <span class="text-danger"
              *ngIf="form.get('additionalNumber')?.touched && form.get('additionalNumber')?.invalid">
          {{ 'Shared.REQUIRED' | translate }}
        </span>
      </div>

      <!-- District -->
      <div class="field col-12 md:col-3">
        <label for="district">
          {{ 'address.district' | translate }} <span class="input-star">*</span>
        </label>
        <input id="district" type="text" pInputText formControlName="district" [disabled]="isDetails" />
        <span class="text-danger"
              *ngIf="form.get('district')?.touched && form.get('district')?.invalid">
          {{ 'Shared.REQUIRED' | translate }}
        </span>
      </div>

      <!-- City -->
      <div class="field col-12 md:col-3">
        <label for="city">
          {{ 'address.city' | translate }} <span class="input-star">*</span>
        </label>
        <input id="city" type="text" pInputText formControlName="city" [disabled]="isDetails" />
        <span class="text-danger"
              *ngIf="form.get('city')?.touched && form.get('city')?.invalid">
          {{ 'Shared.REQUIRED' | translate }}
        </span>
      </div>

      <!-- Postal Code -->
      <div class="field col-12 md:col-3">
        <label for="postalCode">
          {{ 'address.postalCode' | translate }} <span class="input-star">*</span>
        </label>
        <input id="postalCode" type="text" pInputText formControlName="postalCode" [disabled]="isDetails" />
        <span class="text-danger"
              *ngIf="form.get('postalCode')?.touched && form.get('postalCode')?.invalid">
          {{ 'Shared.REQUIRED' | translate }}
        </span>
      </div>

      <!-- Unit Number -->
      <div class="field col-12 md:col-3">
        <label for="unitNumber">
          {{ 'address.unitNumber' | translate }}
        </label>
        <input
          id="unitNumber"
          type="text"
          inputmode="numeric"
          pInputText
          formControlName="unitNumber"
          (input)="onUnitNumberInput()"
          [disabled]="isDetails"
        />
        <span
          class="text-danger"
          *ngIf="form.get('unitNumber')?.touched && form.get('unitNumber')?.hasError('pattern')"
        >
          {{ 'validation.invalidNumber' | translate }}
        </span>
      </div>

    </ng-container>

  </div>
</form>
